export enum InfoMessages {
  ShowHowManyDetails = 'CThB',
  OrderItemsNoLongerAvailable = 'iuhA',
  ItemListModified = 'DfQE',
  ItemIsLocated = 'wcTj',
  TheDisabledFieldsAlwaysPrinted = '0FuT',
  AllRightsClaim = 'b/I8',
  ExportFooterText = 'fcZW',
  ActionWasSuccessfullyDone = 'EQkH',
  SubmittedSuccessfully = 'Fejr',
  SavedSuccessfully = 'UTTX',
  YouHaveNotAddedAnyItemsYet = 'HLFA',
  DefaultOrderingUnitHint = 'a03q',
  UnitCostIsLastPurchaseCostOfInventoryItem = 'jBzJ',
  VendorAssignProductItemCode = 'oGtD',
  DefaultPurchaseOrderingUnit = 'Km5L',
  FilterOrderListTips = 'Zv6z',
  DashboardTransferDateMoreThan = 'EfpC',
  DashboardWidgetsAutoRefreshSwitchLabel = 'FZVD',
  LastXDays = '8eRz',
  AutoRestockWillCreatePreEventBaseOnLatestEvent = 'GdAy',
  Didsuccessfully = 'BL0j',
  PartialOrAllsuccessfully = '4PQl',
  YouCanSelectUpToTargets = 'wVIV',
  PerformingACountWhileAnEventIsOpenMessage = 'Xai5',
  HierarchyTitle = 'xrlK',
  $IndicatesChargeableItemsBrackets = 'sdIK',
  TransferRequestStillInDraft = 'svO0',
  TransferIsAPartOfGroup = 'rB3i',
  SomeItemsCannotBeDuplicated = 'o1yC',
  UnavailableItemList = 'orqZ',
  TransferDestinationsInfoMsg = 'CT4p',
  TransferNullNewSitesWillRemoved = '1g30',
  ItemsIsNoLongerAvailable = 'iFUE',
  NoAnyConfiguredTypeForItems = 'Wf+L',
  ThresholdWarningMessage = 'Ckax',
  TransferQOHTooltips = 'IUuN',
  TransferUnitCostTooltips = 's+4z',
  AreYouSureYouWantToDiscardAllChanges = '71B8',
  AreYouSureYouWantToRemoveTheSelectedTemplates = 'FbWr',
  AreYouSureYouWantToRemoveThisTemplate = 'Aqdj',
  DuplicateSiteNotAvailable = 'Blo5',
  DuplicateSitesNotAvailable = 'jFXT',
  DuplicateWarehouseError = 'Pcjb',
  PleaseVerifySitesAndWarehouse = 'jsPf',
  ReplenishOptionsTooltip = 'G5l+',
  TransferQOHTooltipMessage = 'IUuNB',
  TransferUnitCostTooltipMessage = 's+4z4',
  DMSyncInfoMessage = 'S3H5',
  WillRemoveTransferOnceSubmitted = 'Jt9K',
  PleaseReviewDMBeforeDoing = 'M2bS',
  TransfersNeedDMSyncBeforeDoing = '9lpQ',

  WillCreateTransferOnceSubmitted = 'clUD',

  PleaseSelectEventType = 'V2n/',
  PleaseSelectEvent = 'otMvA',
  NoAvailableSites = 'DmX8',

  TransferRequestAutoRefreshTooltip = '+mS3',
  GreenStatusTooltip = 'Tu7O',
  UnprocessedStatusTooltip = 'VkyG',
  DiscardTransferGroup = '9h4c',
  TransferFilterListTooltip = '6Gfc',
  PleaseVerifyAssignmentSites = 'HthT',
  PleaseVerifyPrimaryWarehouseSettings = 'M1zo',
  ConfirmationModalRemovesSites = 'oUgL',
  BulkReplenishFailedMessage = 'n3EK',
  TransferGroupDMSyncTooltipMessage = 'J9EG',
  BulkReplenishSuccessMessage = 'J5aX',
  YouCanSelectUpToPrintAndExport = '2GTq',
  TransferGroupVoidAdverselyImpactQOH = 'rksK',
  VoidAdverselyImpactQOH = '2QlL',

  DuplicateTitle = '+tnB',
  CannotDuplicateTransferDueToEventClosed = 'XoXt',

  ConsiderReducingYourQuantityRequestedToLessThan = 'iwDY',
  ConsiderIncreasingYourQuantityRequestedToGreaterThan = 'TL8N',
  ConsiderIncreasingYourQuantityRequestedTo = 'knvl',
  ConsiderReducingYourQuantityRequestedTo = 'Co20',

  AreYouSureYouWantToRemoveThisEntity = '751g',
  UnableToEditMoreThanLimitItems = 'rIWz',
  UnableToEditMultipleEntitiesWithDifferentFields = 'ver7',
  AreYouSureYouWantToSaveTheChangesAndReopenThisEntity = 'ZtGT',

  OnlyNewTransfersWillBeAreYouContinue = 'rraP',
  AreYouSureYouWantToSubmitTheEntity = 'VKYx',
  CannotEditStandWorksheet = 'eLPh',
  CannotOperateStandWorksheet = 'CQ6R',
  HavePendingTransfersOnThisSite = 'VEa3',
  NoEnableStandWorksheet = 'nK/x',
  NoActiveStandWorksheetError = '4q9Y',
  LoadingFailedError = 'NQP3',
  FailedToOperation = 'lGdc',
  NoStandWorksheetCanBeCanceled = 'zFsh',
  CanceledAllOpenStandWorksheets = 'WwN9',
  CanceledStandWorksheetFailed = 'SFNg',
  NoEventsToShow = '1tpg',

  AreYouSureYouWantToDo = 'doTk',
  SaveTransferGroupBeforeProcess = 'EbnJ',
  UnsavedTileExit = 'd4KN',

  ProgressCurrentProcessedSuccessfully = 'JtAi',
  CountsUnsavedChangesMessageMade = 'C5qO',
  OopsSomethingWentWrong = 'C+LT',
  NoStandWorksheet = 'RGTc',
  NoTransfer = 'LBWK',
  ThePreviouslySelectedEventIsNotAvailableAnyMore = 'rMf0',
  ProductsWereSuccessfullyUpdated = 'xHPA',
  SuchValueHasAlreadyBeenAdded = 'wuTw',

  ViewOperationCompletedSuccessfully = 'T0i5',

  SignatureLinesTooltips = 'wx/I',
  TotalsTooltips = 'YZ+d',
}
